export default {
  "name": "NCCardTable",
  "column": 1,
  "canAppend": false,
  "type": 1,
  "path": "LowCodeComponents.NCCardTable",
  "label": "多页签表格",
  "schema": {
    "type": "object",
    "properties": {
      "moduleId": {
        "title": "区域编码",
        "description": "区域编码",
        "type": "string"
      },
      "showIndex": {
        "title": "显示序号",
        "description": "显示序号",
        "type": "boolean",
        "default": false
      },
      "showCheck": {
        "title": "显示复选框",
        "description": "显示复选框",
        "type": "boolean",
        "default": true
      },
      "height": {
        "title": "是否滚动加载",
        "description": "是否滚动加载",
        "type": "number"
      },
      "lazyload": {
        "title": "是否滚动加载",
        "description": "是否滚动加载",
        "type": "boolean",
        "default": true
      },
      "adaptionHeight": {
        "title": "是否自适应高度",
        "description": "是否自适应高度",
        "type": "boolean",
        "default": true
      },
      "isAddRow": {
        "title": "最后一行录入数据自动增行",
        "description": "最后一行录入数据自动增行",
        "type": "boolean",
        "default": false
      },
      "multipleRowCell": {
        "title": "是否显示多行",
        "description": "是否显示多行",
        "type": "boolean"
      },
      "rowClassList": {
        "title": "行样式",
        "description": "行样式",
        "type": "string"
      },
      "hideModelSave": {
        "title": "整单保存按钮显隐",
        "description": "整单保存按钮显隐",
        "type": "boolean"
      },
      "hideAdd": {
        "title": "侧拉增行按钮显隐",
        "description": "侧拉增行按钮显隐",
        "type": "boolean"
      },
      "hideDel": {
        "title": "侧拉删行按钮显隐",
        "description": "侧拉删行按钮显隐",
        "type": "boolean"
      },
      "grandTableId": {
        "title": "孙表的id",
        "description": "孙表的id",
        "type": "string"
      },
      "pkcode": {
        "title": "子孙关系code",
        "description": "子孙关系code",
        "type": "string"
      },
      "inModal": {
        "title": "是否在弹窗内",
        "description": "是否在弹窗内",
        "type": "boolean",
        "default": false
      },
      "tableHeadRight": {
        "title": "表头按钮区",
        "description": "表头按钮区",
        "type": "node"
      },
      "tableHeadLeft": {
        "title": "表头左侧区域",
        "description": "表头左侧区域",
        "type": "node"
      },
      "visible": {
        "title": "是否可见",
        "description": "是否可见",
        "type": "boolean"
      }
    },
    "required": [
      "moduleId"
    ]
  },
  "uiSchema": {},
  "slots": [
    "tableHeadRight",
    "tableHeadLeft"
  ]
}